import React from "react";
import * as Icons from "lucide-react";
import { icons, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import useReveal from "../hooks/useReveal";

export default function HowItWorks() {
  const { ref, visible } = useReveal();
  const { lang } = useLang();
  const h = translations[lang].how;

  return (
    <section id="how" className="relative bg-navy angle-top angle-bottom py-28 md:py-36">
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(#ffffff 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="mx-auto max-w-7xl px-5 md:px-8 relative">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-widest text-blue-300">{h.eyebrow}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-white leading-tight">{h.title}</h2>
          <p className="mt-4 text-blue-100/80">{h.subtitle}</p>
        </div>
        <div ref={ref} className={`mt-16 grid md:grid-cols-3 gap-6 reveal ${visible ? "is-visible" : ""}`}>
          {h.steps.map((s, i) => {
            const meta = icons.how[i] || {};
            const Icon = Icons[meta.icon] || Icons.Circle;
            return (
              <div key={i} className="relative group rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-white/10 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="font-display text-4xl font-extrabold text-white">{meta.step}</span>
                  <div className="grid h-14 w-14 place-items-center rounded-2xl bg-cblue text-white shadow-lg"><Icon className="h-7 w-7" /></div>
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-3 text-blue-100/75 text-sm leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
